import { ChangeDetectionStrategy, Component } from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { Connect25EmailTemplateAdminComponent } from "./connect25.email.template.admin.component";

@TypeManagerDecorator("s25-ng-se-email-template-settings-page")
@Component({
    selector: "s25-ng-se-email-template-settings-page",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [Connect25EmailTemplateAdminComponent],
    template: `
        <div class="c-padding--double se-email-template-settings-page">
            <s25-ng-connect25-email-template-admin />
        </div>
    `,
    styles: `
        :host {
            display: block;
        }
    `,
})
export class SeEmailTemplateSettingsPageComponent {}
